<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"> </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator-button">
      <a-button @click="handleEditClick" type="primary" icon="edit">{{
        isEditStatus ? '退出编辑' : '进入编辑'
      }}</a-button>
      <a-button v-if="isEditStatus === true" @click="handleSaveClick" type="primary" icon="save">保存</a-button>
      <a-button v-if="isEditStatus === true" @click="handleAddClick" type="primary" icon="plus">新增</a-button>
      <a-button
        style="margin-left: auto"
        v-if="isEditStatus === false"
        type="primary"
        @click="searchQuery"
        icon="search"
        >查询</a-button
      >
    </div>
    <!-- table区域-begin -->
    <div class="margin-top-20px">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <div slot="projectName" slot-scope="text">
          <span>{{ text }}</span>
        </div>
        <div slot="departId" slot-scope="text, record">
          <a-input readonly v-if="isEditStatus" :value="record.departName" @click="handleDepartClick(record)"></a-input>
          <span v-else>{{ record.departName }}</span>
        </div>
        <div slot="accountedRevenue" slot-scope="text, record">
          <a-input-number
            :min="1"
            :max="100"
            v-model="record.accountedRevenue"
            :readonly="!isEditStatus"
            @change="$set(record, 'isEdit', true)"
          ></a-input-number>
        </div>
        <div slot="action" slot-scope="text, record, index">
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(index)">
            <a>删除</a>
          </a-popconfirm>
        </div>
        <div class="edit-dot-td" slot="isEdit" slot-scope="text">
          <div class="edit-dot" :class="{ 'isedit-status-red': text, 'isedit-status-gree': !text }"></div>
        </div>
      </a-table>
    </div>
    <j-select-depart-modal ref="selectDepartRef" @ok="handleSelectDepartOk"></j-select-depart-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction } from '@/api/manage'
import JSelectDepartModal from '@/components/jeecgbiz/modal/JSelectDepartModal.vue'

export default {
  name: 'BusDailyProjectDepartList',
  components: {
    JSelectDepartModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      description: '项目的收益部门和收益比例管理页面',
      // 表头
      columns: [],
      url: {
        list: '/dailyproject/busDailyProjectDepart/list',
        delete: '/dailyproject/busDailyProjectDepart/delete',
        deleteBatch: '/dailyproject/busDailyProjectDepart/deleteBatch',
        exportXlsUrl: '/dailyproject/busDailyProjectDepart/exportXls',
        importExcelUrl: 'dailyproject/busDailyProjectDepart/importExcel',
        add: '/dailyproject/busDailyProjectDepart/add',
      },
      dictOptions: {},
      isEditStatus: false,
      currentRecord: {},
    }
  },
  methods: {
    initDictConfig() {},
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      params.projectId = this.projectRecords[0].id
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    handleDepartClick(record) {
      this.currentRecord = record
      this.$refs.selectDepartRef.show()
    },
    handleSelectDepartOk(record) {
      console.log(record)
      if (!record || record.length === 0) {
        this.$message.error('当前未做选择')
        return
      }
      this.$set(this.currentRecord, 'departId', record[0].id)
      this.$set(this.currentRecord, 'departName', record[0].departName)
      this.$set(this.currentRecord, 'isEdit', true)
    },
    handleAddClick() {
      this.dataSource.push({
        projectId: this.projectRecords[0].id,
        departId: '',
        accountedRevenue: 0,
        isEdit: true,
      })
    },
    handleSaveClick() {
      console.log(this.dataSource)
      let departStatus = true
      let totalData = this.dataSource.reduce((total, item) => total + item.accountedRevenue, 0)
      if (totalData !== 100) {
        this.$message.error('受益占比之和必须为100')
        departStatus = false
        return
      }
      this.dataSource.forEach((element) => {
        if (element.departId == '') {
          this.$message.error('请选择收益部门')
          departStatus = false
          return
        } else if (element.accountedRevenue == null) {
          this.$message.error('请输入收益占比')
          departStatus = false
          return
        }
      })
      console.log(departStatus)
      if (departStatus === true) {
        postAction(this.url.add, this.dataSource).then((res) => {
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.isEditStatus = false
            this.loadData(1)
          }
        })
      }
    },
    handleEditClick() {
      if (this.isEditStatus) {
        if (this.dataSource.length === 0) {
          this.isEditStatus = !this.isEditStatus
          return
        }
        let isEdited = this.dataSource.some((item) => {
          return item.isEdit
        })
        if (isEdited) {
          this.$antdConfirm({
            title: '取消编辑',
            content: '您尚未保存内容，退出会丢失全部，是否确定？',
            onOk: () => {
              this.isEditStatus = !this.isEditStatus
              this.loadData(1)
            },
          })
        } else {
          this.isEditStatus = !this.isEditStatus
        }
      } else {
        this.isEditStatus = !this.isEditStatus
      }
    },
    handleDelete: function (id) {
      this.dataSource.splice(id, 1)
    },
  },
  watch: {
    isEditStatus: {
      handler(newVal) {
        if (newVal) {
          this.columns = [
            {
              title: '收益部门',
              align: 'center',
              dataIndex: 'departId',
              scopedSlots: { customRender: 'departId' },
              with: '25%',
            },
            {
              title: '收益占比',
              align: 'center',
              dataIndex: 'accountedRevenue',
              scopedSlots: { customRender: 'accountedRevenue' },
              with: '25%',
            },
            {
              title: '改动',
              align: 'center',
              dataIndex: 'isEdit',
              scopedSlots: { customRender: 'isEdit' },
              with: '20%',
            },
            {
              title: '操作',
              align: 'center',
              dataIndex: 'action',
              scopedSlots: { customRender: 'action' },

              with: '25%',
            },
          ]
        } else {
          this.columns = [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: 'center',
              customRender: function (t, r, index) {
                return parseInt(index) + 1
              },
            },
            {
              title: '收益部门',
              align: 'center',
              dataIndex: 'departId',
              scopedSlots: { customRender: 'departId' },
              with: '30%',
            },
            {
              title: '收益占比',
              align: 'center',
              dataIndex: 'accountedRevenue',
              scopedSlots: { customRender: 'accountedRevenue' },
              with: '40%',
            },
          ]
        }
      },
      immediate: true,
    },
    projectRecords: {
      handler() {
        this.loadData(1)
      },
      immediate: true,
    },
  },
  props: {
    projectRecords: {
      type: Array,
      default: [],
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.edit-dot-td {
  display: flex;
  justify-content: center;
  align-items: center;
  .edit-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
  .isedit-status-red {
    background-color: red !important;
  }
  .isedit-status-gree {
    background-color: green !important;
  }
}
</style>
